import Amplify, { Auth } from 'aws-amplify';
import axios from '../axios';

import awsExports from '../aws-exports';

Amplify.configure(awsExports);

const disallowedUserTypes = ['maintainer'];

function setUserInfo(user, userType, userData) {
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('userId', JSON.stringify(userData.id));
}

export async function signIn({ username, password }) {
  const awsUser = await Auth.signIn(username, password);
  if (awsUser.challengeName === 'NEW_PASSWORD_REQUIRED') {
    return { awsUser };
  }
  const type = awsUser.attributes['custom:userType'];

  if (disallowedUserTypes.includes(type)) {
    throw new Error('User does not exists.');
  }

  const requestedUser = await axios.get(`/user/signIn`);
  setUserInfo(awsUser, type, requestedUser.data);
  return { awsUser, user: requestedUser.data };
}

export async function signOut() {
  await axios.get(`/user/signOut`);
  await Auth.signOut();
  // eslint-disable-next-line
  clearUserInfo();
}

export async function impersonate(user) {
  const { id, type } = user;
  const impersonateUser = await axios.post('/user/impersonate', {
    id,
    userType: type,
  });
  localStorage.setItem('impersonate', JSON.stringify(impersonateUser?.data || user));

  return impersonateUser?.data || user;
}

export async function unImpersonate() {
  await axios.delete('/user/impersonate');
  localStorage.removeItem('impersonate');
}

function clearUserInfo() {
  localStorage.removeItem('user');
  localStorage.removeItem('userId');
  localStorage.removeItem('impersonate');
  localStorage.removeItem('admin');
}
